// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import router from './router'
import * as echarts from 'echarts'
import api from './common/request/api'
import store from './store'
import 'default-passive-events'
import axios from 'axios'

Vue.config.productionTip = false

Vue.use(Element, { size: 'small', zIndex: 3000 })
Vue.prototype.$echarts = echarts

Vue.prototype.$store = store

axios.defaults.baseURL = (store.state.reqMode === 'udp') ? 'http://localhost:8802' : 'https://api.pqmeter.cn'
Vue.prototype.$api = api

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js